module.exports = {
    endPoints: {
        GET_OFFERS_REWARDS: 'api/Springbig/get-offers-rewards',
        APPLY_REWARD: 'api/Springbig/apply-reward',
        APPLY_OFFER: 'api/Springbig/apply-offer',
    }
}


// WEBPACK FOOTER //
// ./ui_src/app/constants/SpringBigConstants.jsx